import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import resourcesType, { namespaces } from '@i18n/manifest';

declare module 'i18next' {
  interface CustomTypeOptions {
    resources: typeof resourcesType;
    returnObjects: true;
  }
}

const languages = ['en', 'en-US', 'en-GB', 'en-AU', 'es', 'es-US', 'de', 'fr', 'it', 'ja'];
const resources: Record<string, Record<string, string>> = {};

for (const language of languages) {
  for (const namespace of namespaces) {
    if (typeof resources[language] === 'undefined') {
      resources[language] = {};
    }
    resources[language][namespace] = require(`../locales/${language}/${namespace}.json`);
  }
}

i18n.use(initReactI18next).init({
  initAsync: false,
  returnObjects: true,
  ns: ['home'],
  fallbackLng: 'en-US',
  debug: true,
  react: {
    useSuspense: true,
  },
  interpolation: {
    escapeValue: false, // not needed for react as it escapes by default
  },
  resources,
});

export default i18n;
